let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hu2tA")).then(() => parcelRequire('99xnO'));